<template lang="pug">
  #LabelIndex.container-width
    .mt-3.px-3
      .row.no-gutters.mb-3
        .col-6.pr-1
          b-button(
            :variant="nowSelect === 'backend' ? 'primary' : 'outline-primary'",
            block,
            @click="changeStatusHandler('backend')"
          ) 公司建立
        .col-6.pl-1
          b-button(
            :variant="nowSelect === 'ba' ? 'primary' : 'outline-primary'",
            block,
            @click="changeStatusHandler('ba')"
          ) 顧問建立
      p.mb-0.text-center(
        v-if="noData"
      ) 無更多資料
      b-button(
        variant="primary",
        class="mb-3",
        v-if="nowSelect === 'ba'"
      )
        router-link.text-white(
          :to="{ name: 'sm-label-create' }"
        )
          i.fas.fa-tag.mr-1
          | 新增顧客標籤
      b-card.border-0.mb-2.customerCard.word-break-all(
        bg-variant="light",
        v-for="(tag,index) in tags",
        :key="tag.id"
      )
        .row
          .col-10.d-flex.align-items-center
            span.mr-3 {{ tag.tag_name }}
            i.fas.fa-user.mr-1.text-danger
            span.text-danger {{ tag.use_count }}
          .col-2.d-flex.align-items-center.justify-content-end.toolsButton
            label.mb-0.d-flex.flex-row-reverse.position-relative(
              :for="`dropTools_${index}`"
              @click="toolsHandler(index)"
            )
              input.toolsInput.d-none(
                type="checkbox",
                :id="`dropTools_${index}`",
                :name="`dropTools_${index}`",
                :checked="toolsOpen.indexOf(index) !== -1"
              )
              b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.iconToolsBtn(
                variant="primary"
              )
                i.fas.fa-tools.iconTools
              b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.position-absolute.iconPushBtn(
                variant="primary",
                @click="pushHandler(tag)"
              )
                i.fas.fa-volume-up.iconPush
              b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.position-absolute.iconEditBtn(
                variant="primary",
                @click="editHandler(tag)"
              )
                i.fas.fa-pencil-alt.iconEdit
              b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.position-absolute.iconDeleteBtn(
                variant="primary",
                @click="deleteHandler(tag)",
                v-if="nowSelect === 'ba'"
              )
                i.far.fa-trash-alt.iconDelete
</template>

<script>
import { mapState } from 'vuex';
import defaultPhotoStickerUrl from '@/assets/images/default/defaultImg404.png';
import { SM_LABEL_EDIT } from '@/router/sm/label';
import { SM_GROUP_PUSH_INDEX } from '@/router/sm/group-push';

export default {
  name: 'LabelIndex',
  data() {
    return {
      defaultPhotoSticker: `this.src="${defaultPhotoStickerUrl}"`,
      nowSelect: 'backend',
      toolsOpen: []
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.getBackendTagsHandler();
  },
  methods: {
    // 取得前台標籤
    getTagsHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '標籤載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 取得標籤
      vm.$store.dispatch('sm_label/getTagsHandler')
        .then(() => {
          vm.$swal.close();
        });
    },
    // 取得後台標籤
    getBackendTagsHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '標籤載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 取得標籤
      vm.$store.dispatch('sm_label/getBackendTagsHandler')
        .then(() => {
          vm.$swal.close();
        });
    },
    toolsHandler(index) {
      const vm = this;
      if (vm.toolsOpen.indexOf(index) === -1) {
        vm.toolsOpen.push(index);
      } else {
        vm.toolsOpen.splice(vm.toolsOpen.indexOf(index), 1);
      }
    },
    pushHandler(tag) {
      const vm = this;
      if (!tag.use_count || tag.use_count === 0) return;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });

      let apiTarget;

      switch (vm.nowSelect) {
        case 'ba':
          apiTarget = 'showTagHandler';
          break;
        case 'backend':
          apiTarget = 'showBackendTagHandler';
          break;
        default:
          break;
      }

      if (!vm.nowSelect || !apiTarget) {
        vm.$swal.fire({
          icon: 'error',
          title: '推播目標錯誤[Err: Not Has NowSelect]'
        });
        return;
      }

      vm.$store.dispatch(`sm_label/${apiTarget}`, {
        tag_id: tag.tag_id
      })
        .then((res) => {
          vm.$swal.close();
          vm.$store.commit('sm_group_push/setMemberList', res.has_tag_members);
          vm.$router.push({
            name: SM_GROUP_PUSH_INDEX
          });
        });
    },
    editHandler({ tag_id = 'test' }) {
      const vm = this;
      vm.$router.push({
        name: SM_LABEL_EDIT,
        params: {
          tag_id,
          mode: vm.nowSelect
        }
      });
    },
    deleteHandler(tag) {
      const vm = this;
      vm.$swal.fire({
        title: '您確定刪除標籤?',
        text: '刪除後標籤無法復原！',
        html: `請注意，刪除後已經貼標的顧客將失去<span style="color: #d33"> ${tag.tag_name} </span> 標籤`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary px-5'
        }
      }).then((result) => {
        if (result.value) {
          vm.$swal.fire({
            title: '標籤刪除中，請稍候',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          vm.$store.dispatch('sm_label/destroyTagHandler', {
            tag_id: tag.tag_id
          })
            .then(() => {
              vm.$swal.close();
              vm.$snotify.success(null, '刪除成功');
              vm.$store.commit('sm_label/resetAll');
              vm.getTagsHandler();
            });
        }
      });
    },
    changeStatusHandler(type) {
      const vm = this;
      switch (type) {
        case 'ba':
          if (vm.nowSelect === 'ba') return;
          vm.nowSelect = 'ba';
          vm.$store.commit('sm_label/resetAll');
          vm.getTagsHandler();
          break;
        case 'backend':
          if (vm.nowSelect === 'backend') return;
          vm.nowSelect = 'backend';
          vm.$store.commit('sm_label/resetAll');
          vm.getBackendTagsHandler();
          break;
        default:
          break;
      }
    }
  },
  computed: {
    ...mapState({
      tags: (state) => state.sm_label.tags,
      noData: (state) => state.sm_label.noData
    })
  }
};
</script>

<style lang="scss" scoped>

.iconBtn {
  position: absolute;
  transition: all .3s;
  right: 0;
  width: 40px;
  height: 40px;
}

.iconToolsBtn {
  position: relative;
  z-index: 5;
  transition: all .3s;
  transform: scale(1.1);
}

.toolsInput:checked + .iconToolsBtn {
  transform: scale(1);
}

.toolsInput:checked ~ .iconPushBtn {
  right: 42px;
}

.toolsInput:checked ~ .iconEditBtn {
  right: 84px;
}

.toolsInput:checked ~ .iconDeleteBtn {
  right: 126px;
}
</style>
